import { language as lan_fixPrice } from "./fix-price";
import { language as lan_simpleTablePrice } from "./simple-table-price";
import { language as lan_priceConfigByRevenue } from "./price-config-by-revenue";

let language = {
    // 固定价格
    ...lan_fixPrice,
    // 计价表单
    ...lan_simpleTablePrice,
    // 可配置产品计价
    ...lan_priceConfigByRevenue,

    STORE_PRODUCT_SETTING_PRICING_TITLE: "产品定价",
    STORE_PRODUCT_SETTING_PRICING_DES1: "您可以设置每件商品的固定价格，或使用数量表提供批量折扣。",
    STORE_PRODUCT_SETTING_PRICING_DES2: "您还可以设置所需的利润率，我们将相应地配置零售价。",
    STORE_PRODUCT_SETTING_PRICING_NOTE: "注意:",
    STORE_PRODUCT_SETTING_PRICING_NOTE_DES: "这些价格不包括税费",
    STORE_PRODUCT_SETTING_PRICING_STORE_DEFAULT_CURRENCY_DES: "{{storeName}} 默认货币为 {{defaultCurrencyTitle}}",
    STORE_PRODUCT_SETTING_PRICING_CHANGE_PRICE_STRATEGY: "更改定价策略",
    STORE_PRODUCT_SETTING_PRICING_CHANGE_FIX_PRICING: "固定价格",
    STORE_PRODUCT_SETTING_PRICING_CHANGE_PRICING_TABLE: "价格表",
    STORE_PRODUCT_SETTING_PRICING_MAX_QTY_TIP: "最大数量必须达到 {{MaxQty}} 才能保存。",
    STORE_PRODUCT_SETTING_PRICING_MIN_QTY_TIP: "最小订单量为 {{productMOQ}}。",
    STORE_PRODUCT_SETTING_PRICE_LOW_PRICE_TIP: "当客户购买此产品时您将获得的收益",
    /********************** qpAlertPrompt 提示框 **************************/
    STORE_PRODUCT_SETTING_PRICE_STORE_CURRENCY_CHANGE_TIP_TITLE: "店铺货币更改",
    STORE_PRODUCT_SETTING_PRICE_STORE_CURRENCY_CHANGE_TIP_DES: "商店的货币变了。 请计算新的汇率，并根据新的货币手动更新产品价格。",
    STORE_PRODUCT_SETTING_PRICE_QTY_LESS_THAN_0_TIP_TITLE: "收入值",
    STORE_PRODUCT_SETTING_PRICE_QTY_LESS_THAN_0_TIP_DES: "收入不能小于0，请重新修改。",
    STORE_PRODUCT_SETTING_PRICE_EMPTY_TIP_TITLE: "定价策略",
    STORE_PRODUCT_SETTING_PRICE_EMPTY_TIP_DES: "定价方法缺失。",
    STORE_PRODUCT_SETTING_PRICE_SAVE_PRICE_FAILD_TIP_TITLE: "产品定价错误",
    STORE_PRODUCT_SETTING_PRICE_SAVE_PRICE_FAILD_TIP_DES: "店铺产品价格非法。请修改店铺产品价格，然后点击“保存产品”以保存店铺产品。",
    STORE_PRODUCT_SETTING_PRICE_UPDATE_PRICE_FAILD_TIP_TITLE: "保存产品定价异常",
    STORE_PRODUCT_SETTING_PRICE_UPDATE_PRICE_ERROR_TIP_TITLE: "保存产品定价失败",
    STORE_PRODUCT_SETTING_PRICE_UPDATE_PRICE_FAILD_TIP_DES: "店铺产品价格非法。请修改店铺产品价格，然后点击“更新产品”以更新店铺产品。",
    STORE_PRODUCT_SETTING_PRICE_LOADING_ISSUE_TITLE:"产品计价加载异常",
    STORE_PRODUCT_SETTING_PRICE_LOADING_ISSUE_CONTENT:"初始化产品计价时出现问题。 请刷新定价步骤并重试。如果问题仍然存在，请随时与我们的支持团队联系 {{supportmail}}。",
    STORE_PRODUCT_SETTING_PRICE_LOADING_ISSUE_CONTENT_MSG:"获取定价策略viewValue失败。 过程 ",
    // whiteLabelPrice价格获取失败
    STORE_PRODUCT_SETTING_PRICE_WHITELABELPRICE_LOADING_ISSUE_TITLE: "产品计价异常",
    STORE_PRODUCT_SETTING_PRICE_WHITELABELPRICE_LOADING_ISSUE_CONTENT: "加载whiteLabelPrice时出现问题。 请刷新定价步骤并重试。如果问题仍然存在，请随时与我们的支持团队联系 {{supportmail}}。",
    STORE_PRODUCT_SETTING_PRICE_WHITELABELPRICE_LOADING_3000601_CONTENT: "不支持商店中的默认货币。 请点击\“{{goStoreBtn}}\”以更新您的默认货币设置并同步价格。",
    STORE_PRODUCT_SETTING_PRICE_WHITELABELPRICE_LOADING_3000601_MSG: "当前店铺货币：{{storeCurrency}}, {{platform}} 品台支持的货币:{{supportCurrency}}",
    STORE_PRODUCT_SETTING_PRICE_CREATE_STORE_PRODUCT_ISSUE: "创建店铺产品异常",
    STORE_PRODUCT_SETTING_PRICE_CREATE_STORE_PRODUCT_ISSUE_CONTENT: "创建商店产品时发生问题。 请刷新定价步骤，然后重试。 如果问题仍然存在，请随时与我们的支持团队联系{{supportmail}}.",
    STORE_PRODUCT_SETTING_PRICE_UPDATE_STORE_PRODUCT_ISSUE: "更新店铺产品异常",
    STORE_PRODUCT_SETTING_PRICE_UPDATE_STORE_PRODUCT_ISSUE_CONTENT: "更新店铺产品时发生问题。 请刷新定价步骤，然后重试。 如果问题仍然存在，请随时与我们的支持团队联系{{supportmail}}.",
    STORE_PRODUCT_SETTING_PRICE_SAVE_STORE_PRODUCT_PRICE_ISSUE: "保存产品失败",
    STORE_PRODUCT_SETTING_PRICE_SAVE_STORE_PRODUCT_PRICE_ISSUE_CONTENT: "保存商店产品价格时发生问题。 请刷新定价步骤，然后重试。 如果问题仍然存在，请随时与我们的支持团队联系 {{supportmail}}.",
    STORE_PRODUCT_SETTING_PRICE_UPDATE_STORE_PRODUCT_PRICE_ISSUE: "保存产品失败",
    STORE_PRODUCT_SETTING_PRICE_UPDATE_STORE_PRODUCT_PRICE_ISSUE_CONTENT: "更新店铺产品价格时发生问题。请刷新定价步骤，然后重试。如果问题仍然存在，请随时与我们的支持团队联系 {{supportmail}}.",
    STORE_PRODUCT_SETTING_PRICE_3000601_CONTENT: "不支持商店中的默认货币。 请点击\“{{goStoreBtn}}\”以更新您的默认货币设置并同步价格。 ",
    STORE_PRODUCT_SETTING_PRICE_3000601_MSG: "店铺货币 {{storeCurrency}}, {{platformCode}}品台支持的货币: {{supportCurrency}}",
    STORE_PRODUCT_SETTING_PRICE_3000697_CONTENT: "此产品的货币与您的商店默认值不匹配。 请选择相应的货币以继续保存产品。",
    STORE_PRODUCT_SETTING_PRICE_3000697_MSG: "店铺默认货币：{{storeCurrency}}。 店铺产品定价货币：{{pricingCurrency}}。",
    STORE_PRODUCT_SETTING_PRICE_TO_STORE: "前往我的店铺",
    STORE_PRODUCT_SETTING_PRICE_OK: "好的",
    STORE_PRICING_DEFAULT_STORE_NAME: "店铺",
    STORE_PRICING_FIX_PRICE_SET_REVENUE_ISSUE_TITLE:"设置收益异常",
    STORE_PRICING_FIX_PRICE_SET_REVENUE_ISSUE_CONTENT_BY_UPDATE_REVENUE:"更新产品收益时发生问题。 请重新设置收益类型并重试。 如果问题仍然存在，请随时与我们的支持团队联系{{supportmail}}.",
    STORE_PRICING_FIX_PRICE_SET_REVENUE_ISSUE_CONTENT_BY_CHANGE_REVENUE:"当设置产品收益时, 更改收益时发生问题。 请重新设置收益类型并重试。 如果问题仍然存在，请随时与我们的支持团队联系{{supportmail}}."
};

export { language }
